/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import intermoji from '@intercom/intermoji';

// SafeString type is not exported, use ReturnType as workaround

/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { SkinToneModifiers } from '@intercom/composer-ember/lib/config/composer-config';
import { hasNativeEmojiSupport } from '@intercom/composer-core';
// Re-export functions from composer-core
export { substituteColonifiedForUnicode, hasNativeEmojiSupport } from '@intercom/composer-core';
export function substituteUnicodeForColonified(text) {
  return intermoji.substituteUnicodeForColonified(text);
}
export function wrapInColons(string) {
  return `:${string}:`;
}
let emojiItems = [];
export function getEmojiItemList(skinToneModifier = SkinToneModifiers.None, rebuild = false) {
  if (rebuild) {
    emojiItems = [];
  }
  if (emojiItems.length === 0) {
    intermoji.prettyEmoticonsIdentifierList().sort().map(identifier => {
      let unicodeIcon = intermoji.unicodeFromIdentifier(identifier);
      if (intermoji.isEmojiBaseUnicode(unicodeIcon) && !intermoji.isUglyNativeEmoji(unicodeIcon)) {
        let display = sanitizeHtml(applySkinTone(unicodeIcon, skinToneModifier));
        if (!hasNativeEmojiSupport()) {
          display = sanitizeHtml(intermoji.fallbackImage(16, display, 'emoji-fallback-image'));
        }
        emojiItems.push({
          identifier,
          unicodeIcon,
          display
        });
      }
    });
  }
  return emojiItems;
}
export function applySkinTone(unicodeIcon, skinToneModifier) {
  if (skinToneModifier === undefined || skinToneModifier === SkinToneModifiers.None) {
    return unicodeIcon;
  }
  let modifiedEmojis = intermoji.getAllModifiedForBaseEmoji(unicodeIcon);
  if (modifiedEmojis.length === 0) {
    return unicodeIcon;
  }
  let matchedSkinToneModifiedEmojis = modifiedEmojis.filter(modifiedEmoji => {
    return Array.from(modifiedEmoji).some(element => element.codePointAt(0) === skinToneModifier);
  });
  return matchedSkinToneModifiedEmojis.length === 1 ? matchedSkinToneModifiedEmojis[0] : unicodeIcon;
}